import SideBarCollapse from './SideBarCollapse';
import './side-bar-collapse.scss';

export default SideBarCollapse;
